/* eslint-disable react-hooks/refs  -- TODO: fix this! (disabled initially when enabling react/hooks rules) */
import { Box, Stack, Typography } from '@mui/material';
import { useRef } from 'react';

import {
  TerminGenerellerKommentarCard,
  TerminPlanungsinformationenCard,
  ThemaHeader,
} from '../../../components/general/index.js';
import { Timeline } from '../../../components/general/Timeline.js';
import { ThemaFromThemaRouter } from '../../../dtos.js';
import { DurchgangListing } from '../DurchgangListing/DurchgangListing.js';
import { TerminAnsprechpartnerCard } from '../TerminAnsprechpartnerCard/index.js';
import { TerminExpertepoolCard } from '../TerminExpertepoolCard/index.js';
import { TerminPlanungsstatusCard } from '../TerminPlanungsstatusCard/index.js';
import { ThemaAusschreibungsprozessCard } from '../ThemaAusschreibungsprozessCard/ThemaAusschreibungsprozessCard.tsx';
import { ThemaEigenschaftenCard } from '../ThemaEigenschaftenCard/index.js';
import { ThemaTasksCard } from '../ThemaTasksCard/ThemaTasksCard.js';
import { ModulCard } from './ModulCard.js';

const SCROLL_TOP_OFFSET = '200px' as const;

type BlendedThemaProps = {
  thema: ThemaFromThemaRouter;
};

export const BlendedThema = ({ thema }: BlendedThemaProps) => {
  // eslint-disable-next-line @eslint-react/naming-convention-ref-name
  const navigation = [
    { label: 'Planung', ref: useRef<HTMLElement>(null) },
    { label: 'Module', ref: useRef<HTMLElement>(null) },
    { label: 'Durchgänge', ref: useRef<HTMLElement>(null) },
    { label: 'Trainer:innen', ref: useRef<HTMLElement>(null) },
    { label: 'Informationen', ref: useRef<HTMLElement>(null) },
  ];

  return (
    <Box>
      <ThemaHeader thema={thema} navigation={navigation} />

      <Stack spacing={6} sx={{ mt: 3 }}>
        <Stack spacing={3}>
          <Typography variant="headingXxs" sx={{ scrollMarginTop: SCROLL_TOP_OFFSET }} ref={navigation[0].ref}>
            {navigation[0].label}
          </Typography>

          <ThemaTasksCard akaThemaId={thema.akaThemaId} />

          <Stack direction="row" spacing={3} justifyContent="space-between">
            <TerminPlanungsinformationenCard thema={thema} withoutAccordion />
            <TerminPlanungsstatusCard thema={thema} />
          </Stack>

          <TerminGenerellerKommentarCard thema={thema} withoutAccordion />
        </Stack>

        <Stack spacing={3}>
          <Typography variant="headingXxs" sx={{ scrollMarginTop: SCROLL_TOP_OFFSET }} ref={navigation[1].ref}>
            {navigation[1].label}
          </Typography>

          <Stack spacing={2}>
            <Timeline
              items={thema.module.map((modul) => ({
                dot: <Typography variant="label">{modul.modulnummer}</Typography>,
                content: <ModulCard key={modul.modulnummer} modul={modul} />,
              }))}
            />
          </Stack>
        </Stack>

        <Stack spacing={3}>
          <Typography variant="headingXxs" sx={{ scrollMarginTop: SCROLL_TOP_OFFSET }} ref={navigation[2].ref}>
            {navigation[2].label}
          </Typography>
          <DurchgangListing thema={thema} />
        </Stack>

        <Stack spacing={3}>
          <Typography variant="headingXxs" sx={{ scrollMarginTop: SCROLL_TOP_OFFSET }} ref={navigation[3].ref}>
            {navigation[3].label}
          </Typography>

          <TerminExpertepoolCard thema={thema} />
        </Stack>

        <Stack spacing={3}>
          <Typography variant="headingXxs" sx={{ scrollMarginTop: SCROLL_TOP_OFFSET }} ref={navigation[4].ref}>
            {navigation[4].label}
          </Typography>

          <Stack spacing={3}>
            <TerminAnsprechpartnerCard thema={thema} />
            <ThemaEigenschaftenCard thema={thema} />
            <ThemaAusschreibungsprozessCard thema={thema} />
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};
